import { ChevronRightIcon } from "@heroicons/react/outline";
import { ShieldCheckIcon } from "@heroicons/react/solid";
import { useTranslation } from "react-i18next";

const Partner = ({ title, description, url }) => {
  const { t } = useTranslation();

  return (
    <div className="flex gap-4 items-center justify-between">
      <div className="flex gap-4 items-center">
        <ShieldCheckIcon
          className="flex-none h-6 w-6 text-green-500"
          aria-hidden="true"
        />
        <div className="flex flex-col text-gray-700 text-sm sm:text-base">
          <span>{t(title)}</span>
          <span className="font-bold">{t(description)}</span>
        </div>
      </div>
      {url && (
        <button
          onClick={() => window.open(url, "_blank")}
          className="font-medium text-gray-700"
        >
          <ChevronRightIcon className="flex-none h-6 w-6" />
        </button>
      )}
    </div>
  );
};

export default Partner;
